import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { MaIcon } from "../../components/ui";

// Wrapper for every /admin/* route. Renders a fixed top bar with section
// tabs and a back-to-app exit, with the active section's screen below.
// Not using <Screen> here because the admin screens manage their own
// scrolling per-section and don't want the bottom-nav assumption baked in.
//
// Desktop polish: header is a centred row (max 1200px), content area
// caps at 1200px and centres itself on wider monitors so tables / forms
// don't sprawl. MobileFrame flips data-wide for /admin so the host
// stretches full-viewport (see theme/styles.css).

const TABS = [
  { to: "/admin/sources", label: "Sources" },
  { to: "/admin/events", label: "Events" },
  { to: "/admin/articles", label: "Articles" },
  { to: "/admin/users", label: "Users" },
];

const MAX_W = 1200;

export function AdminLayout() {
  const navigate = useNavigate();
  return (
    <div className="ma-screen" style={{ display: "flex", flexDirection: "column", background: "var(--ma-paper)" }}>
      <div style={{
        flexShrink: 0,
        borderBottom: "var(--ma-border) solid var(--ma-ink)",
        background: "var(--ma-cream)",
      }}>
        <div style={{
          maxWidth: MAX_W, margin: "0 auto",
          padding: "calc(env(safe-area-inset-top, 20px) + 18px) 20px 0",
        }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12, gap: 12 }}>
            <div>
              <div className="ma-mono" style={{
                fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase",
                color: "var(--ma-brick)", marginBottom: 2,
              }}>
                admin
              </div>
              <div className="ma-display" style={{ fontSize: 26, color: "var(--ma-ink)", lineHeight: 1 }}>
                myams console
              </div>
            </div>
            <button
              onClick={() => navigate("/discover")}
              style={{
                padding: "8px 14px",
                background: "transparent",
                border: "var(--ma-border) solid var(--ma-ink)",
                borderRadius: "var(--ma-card-radius)",
                fontFamily: "var(--ma-mono)", fontSize: 11, letterSpacing: "0.12em",
                textTransform: "uppercase", color: "var(--ma-ink)", cursor: "pointer",
                display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap",
              }}
            >
              <MaIcon name="back" size={11} stroke={2} /> back to app
            </button>
          </div>

          <div style={{ display: "flex", gap: 4, overflowX: "auto" }}>
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                style={({ isActive }) => ({
                  padding: "10px 18px",
                  background: isActive ? "var(--ma-ink)" : "transparent",
                  color: isActive ? "var(--ma-paper)" : "var(--ma-ink)",
                  border: "var(--ma-border) solid var(--ma-ink)",
                  borderBottom: "none",
                  borderTopLeftRadius: "var(--ma-card-radius)",
                  borderTopRightRadius: "var(--ma-card-radius)",
                  fontFamily: "var(--ma-mono)", fontSize: 11, letterSpacing: "0.12em",
                  textTransform: "uppercase", fontWeight: 600,
                  textDecoration: "none", whiteSpace: "nowrap",
                  marginBottom: -1,
                })}
              >
                {t.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      <div style={{ flex: 1, overflowY: "auto" }}>
        <div style={{ maxWidth: MAX_W, margin: "0 auto", padding: "0 8px" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
